@if (icon) {
  <div class="inline-notification-icon"><i class="{{ icon }}"></i></div>
}
<div class="inline-notification-content">
  <ng-content></ng-content>
</div>
